<div class="onboarding-alert-dialog">
    <h2 mat-dialog-title>⚠️ Attenzione!</h2>

    <mat-dialog-content class="dialog-content">
        <p>Per attivare l'operatività con CashMe, è necessario completare la procedura di Onboarding digitale.</p>

        <p *ngIf="!hasOnboardingAccount">
            Clicca su "Avvia" per iniziare.
        </p>

        <p *ngIf="hasOnboardingAccount">
            Clicca su "Riprendi" per continuare.
        </p>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions" align="end">
        <button mat-button (click)="closeDialog()">
            Chiudi
        </button>
        <button mat-raised-button color="primary"
            (click)="hasOnboardingAccount ? resumeOnboarding() : startOnboarding()">
            <span *ngIf="!hasOnboardingAccount">Avvia</span>
            <span *ngIf="hasOnboardingAccount">Riprendi</span>
        </button>
    </mat-dialog-actions>
</div>